import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import uniqid from 'uniqid';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	translate,
	functionSendMail,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const entities_list = useRef(null);

	const active_type = useRef(null);
	const active_state = useRef(null);

	const rmm_type = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [uid,] = useState(uniqid());

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)
	const [treeDataPDF, setTreeDataPDF] = useState([])
	const [treeDataPDFFatura, setTreeDataPDFFatura] = useState([])
	const [treeDataPDFGarantia, setTreeDataPDFGarantia] = useState([])
	const [treeDataPDFManual, setTreeDataPDFManual] = useState([])
	const [treeDataPDFRMM, setTreeDataPDFRMM] = useState([])
	const [treeDataPDFRMMCertificado, setTreeDataPDFRMMCertificado] = useState([])
	const [treeDataPDFRMMAprovacao, setTreeDataPDFRMMAprovacao] = useState([])
	const [treeDataEditable, setTreeDataEditable] = useState([])

	const [files_doc_pdf, set_files_doc_pdf] = useState([]);
	const [files_doc_pdf_name, set_files_doc_pdf_name] = useState([]);
	const [files_doc_editable, set_files_doc_editable] = useState([]);
	const [files_doc_editable_name, set_files_doc_editable_name] = useState([]);
	
	const [files_doc_pdf_fatura, set_files_doc_pdf_fatura] = useState([]);
	const [files_doc_pdf_fatura_name, set_files_doc_pdf_fatura_name] = useState([]);
	const [files_doc_pdf_garantia, set_files_doc_pdf_garantia] = useState([]);
	const [files_doc_pdf_garantia_name, set_files_doc_pdf_garantia_name] = useState([]);
	const [files_doc_pdf_manual, set_files_doc_pdf_manual] = useState([]);
	const [files_doc_pdf_manual_name, set_files_doc_pdf_manual_name] = useState([]);
	const [files_doc_pdf_rmm, set_files_doc_pdf_rmm] = useState([]);
	const [files_doc_pdf_rmm_name, set_files_doc_pdf_rmm_name] = useState([]);
	const [files_doc_pdf_rmm_certificado, set_files_doc_pdf_rmm_certificado] = useState([]);
	const [files_doc_pdf_rmm_certificado_name, set_files_doc_pdf_rmm_certificado_name] = useState([]);
	const [files_doc_pdf_rmm_aprovacao, set_files_doc_pdf_rmm_aprovacao] = useState([]);
	const [files_doc_pdf_rmm_aprovacao_name, set_files_doc_pdf_rmm_aprovacao_name] = useState([]);

	const [notify_responsable_edit, set_notify_responsable_edit] = useState(false)
	const [notify_responsable_aproval, set_notify_responsable_aproval] = useState(false)
	const [notify_responsable_remove, set_notify_responsable_remove] = useState(false)

	const [document_state_list, set_document_state_list] = useState([])

	const [document_state_edit, set_document_state_edit] = useState(false)
	const [document_state_aprove, set_document_state_aprove] = useState(false)
	const [document_state_remove, set_document_state_remove] = useState(false)

	{ console.log('active_type.current', active_type.current) }
	{ console.log('active_state.current', active_state.current) }
	{ console.log('entities_list.current', entities_list.current) }
	{ console.log('dados.current', dados) }

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const fetch_entities_list = async () => {

		let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
		let result = []
		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.entity_type) === parseInt('1'))
		}

		return result

	}

	const fetch_maintenance_attributes = async (type) => {

		let res = await reqGET(`${api_crud_base}/intranet/maintenance/attribute/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {

				let aux = {
					id: el.id,
					name: translate(el.info.title, 'pt')
				}

				result.push(aux)
			}
		}

		return result

	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		set_dados(entities_list.current = [])
		set_dados(active_type.current = [])
		set_dados(active_state.current = [])

		let aux_document_state = [
			{
				id: 0,
				label: 'Em edição'
			},
			{
				id: 1,
				label: 'Aguarda aprovação'
			},
			{
				id: 2,
				label: 'Em revisão'
			},
			{
				id: 3,
				label: 'Aprovado'
			},
			{
				id: 4,
				label: 'Obsoleto'
			},
			{
				id: 5,
				label: 'Eliminado'
			}
		]
		set_document_state_list(aux_document_state)


		const get_attr = async () => {

			let res_1 = await fetch_maintenance_attributes('active_type')
			if (res_1.length > 0) {
				res_1 = order_array(res_1)

				let res_aux_1 = []
				for await (let el of res_1) {
					res_aux_1.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(active_type.current = res_aux_1)
			}
			let res_2 = await fetch_maintenance_attributes('active_state')
			if (res_2.length > 0) {
				res_2 = order_array(res_2)

				let res_aux_2 = []
				for await (let el of res_2) {
					res_aux_2.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(active_state.current = res_aux_2)
			}
			let res_3 = await fetch_maintenance_attributes('rmm_type')
			if (res_3.length > 0) {
				res_3 = order_array(res_3)

				let res_aux_3 = []
				for await (let el of res_3) {
					res_aux_3.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(rmm_type.current = res_aux_3)
			}
			let res_4 = await fetch_entities_list()
			if (res_4.length > 0) {
				res_4 = order_array(res_4)

				let res_aux_4 = []
				for await (let el of res_4) {
					res_aux_4.push({
						id: el.id,
						label: el.name,
						email: el.email
					})
				}
				set_dados(entities_list.current = res_aux_4)
			}

			setLoading(false);

			return true

		}

		const fetch_id_info = async (id_serch) => {

			try {

				let res = await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
				set_dados(dados.current = res.data[0]);

				if (Array.isArray(res.data) && res.data.length > 0) {
					if (res.data[0]?.info?.file?.pdf !== undefined && Array.isArray(res.data[0].info.file.pdf)) {
						let aux_doc_pdf = []
						let i = 0

						for await (let el of res.data[0].info.file.pdf) {
							if (aux_doc_pdf[0] === undefined)
								aux_doc_pdf[0] = []
							if (aux_doc_pdf[0][1] === undefined)
								aux_doc_pdf[0][1] = []

							// aux_doc_pdf[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDF(aux_doc_pdf)
					}
					if (res.data[0]?.info?.file?.editable !== undefined && Array.isArray(res.data[0].info.file.editable)) {
						let aux_doc_editable = []
						let i = 0

						for await (let el of res.data[0].info.file.editable) {
							if (aux_doc_editable[0] === undefined)
								aux_doc_editable[0] = []
							if (aux_doc_editable[0][1] === undefined)
								aux_doc_editable[0][1] = []

							// aux_doc_editable[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_editable[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataEditable(aux_doc_editable)
					}
					if (res.data[0]?.info?.file?.fatura !== undefined && Array.isArray(res.data[0].info.file.fatura)) {
						let aux_doc_pdf_fatura = []
						let i = 0

						for await (let el of res.data[0].info.file.fatura) {
							if (aux_doc_pdf_fatura[0] === undefined)
								aux_doc_pdf_fatura[0] = []
							if (aux_doc_pdf_fatura[0][1] === undefined)
								aux_doc_pdf_fatura[0][1] = []

							// aux_doc_pdf_fatura[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf_fatura[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDFFatura(aux_doc_pdf_fatura)
					}
					if (res.data[0]?.info?.file?.garantia !== undefined && Array.isArray(res.data[0].info.file.garantia)) {
						let aux_doc_pdf_garantia = []
						let i = 0

						for await (let el of res.data[0].info.file.garantia) {
							if (aux_doc_pdf_garantia[0] === undefined)
								aux_doc_pdf_garantia[0] = []
							if (aux_doc_pdf_garantia[0][1] === undefined)
								aux_doc_pdf_garantia[0][1] = []

							// aux_doc_pdf_garantia[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf_garantia[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDFGarantia(aux_doc_pdf_garantia)
					}
					if (res.data[0]?.info?.file?.manual !== undefined && Array.isArray(res.data[0].info.file.manual)) {
						let aux_doc_pdf_manual = []
						let i = 0

						for await (let el of res.data[0].info.file.manual) {
							if (aux_doc_pdf_manual[0] === undefined)
								aux_doc_pdf_manual[0] = []
							if (aux_doc_pdf_manual[0][1] === undefined)
								aux_doc_pdf_manual[0][1] = []

							// aux_doc_pdf_manual[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf_manual[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDFManual(aux_doc_pdf_manual)
					}
					if (res.data[0]?.info?.file?.pdf_rmm !== undefined && Array.isArray(res.data[0].info.file.pdf_rmm)) {
						let aux_doc_pdf_rmm = []
						let i = 0

						for await (let el of res.data[0].info.file.pdf_rmm) {
							if (aux_doc_pdf_rmm[0] === undefined)
								aux_doc_pdf_rmm[0] = []
							if (aux_doc_pdf_rmm[0][1] === undefined)
								aux_doc_pdf_rmm[0][1] = []

							// aux_doc_pdf_rmm[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf_rmm[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDFRMM(aux_doc_pdf_rmm)
					}
				}

				set_is_edit(true)

				get_attr()

			} catch (error) {
				console.error("Erro:", error);
			}
		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				fetch_id_info(props.location.state.item.id)
			}
			else {
				get_attr()
			}

		} catch {
			clean_data()

			get_attr()

			return
		}

	}, [props]);

	const handleSubmit = async e => {
		e.preventDefault();

		let today = new Date();
		let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

		if (is_edit === true) {

			await Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						if (document_state_aprove) {
							dados.current.info.settings.document_state = "3"

							dados.current.info.responsable.aproval.execution = today
							dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today
						}

						if (notify_responsable_edit) {
							if (dados.current.info.responsable.edit.id !== '') {
								let aux_id = dados.current.info.responsable.edit.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.edit.notification = today
								dados.current.info.responsable.edit.execution = today

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})

									dados.current.info.responsable.aproval.id = ''
									dados.current.info.responsable.aproval.name = ''
									dados.current.info.responsable.aproval.notification = ''
									dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
									}
									else {
										dados.current.info.historic.push({
											edit: {
												id: aux_responsable[0].id,
												name: aux_responsable[0].label,
												date: today
											},
											aproval: {
												id: '',
												name: '',
												date: ''
											}
										})

										dados.current.info.settings.document_state = "1"

										dados.current.info.responsable.aproval.id = ''
										dados.current.info.responsable.aproval.name = ''
										dados.current.info.responsable.aproval.notification = ''
										dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.aproval.notification = today

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados.current.info.responsable.remove.id !== '') {

								dados.current.info.responsable.remove.notification = today
								dados.current.info.responsable.remove.execution = today

							}

						}

						for await (let el_doc of files_doc_pdf) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf([])
						set_files_doc_pdf_name([])

						for await (let el_doc of files_doc_editable) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_editable([])
						set_files_doc_editable_name([])

						for await (let el_doc of files_doc_pdf_fatura) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'fatura', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_fatura([])
						set_files_doc_pdf_fatura_name([])

						for await (let el_doc of files_doc_pdf_garantia) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'garantia', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_garantia([])
						set_files_doc_pdf_garantia_name([])

						for await (let el_doc of files_doc_pdf_manual) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'manual', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_manual([])
						set_files_doc_pdf_manual_name([])

						for await (let el_doc of files_doc_pdf_rmm) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf_rmm', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_rmm([])
						set_files_doc_pdf_rmm_name([])

						for await (let el_doc of files_doc_pdf_rmm_certificado) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf_rmm_certificado', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_rmm_certificado([])
						set_files_doc_pdf_rmm_certificado_name('')

						for await (let el_doc of files_doc_pdf_rmm_aprovacao) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf_rmm_aprovacao', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_rmm_aprovacao([])
						set_files_doc_pdf_rmm_aprovacao_name('')


						await reqPUT(api_crud_route, dados.current)
							.then(async () => {
								if (notify_responsable_edit) {

								}
								if (notify_responsable_aproval) {
									if (dados.current.info.responsable.aproval.id !== '') {

										let aux_id = dados.current.info.responsable.aproval.id
										let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										if (Array.isArray(aux_responsable) && aux_responsable.length > 0) {

											let aux = {
												id: dados.current.id,
												uniqid: dados.current.info.uniqid,
												companycode: dados.current.info.companycode,

												type: 'maintenance',
												title: translate(dados.current.info.title, lang),
												description: translate(dados.current.info.description, lang),
												responsaveis: [{
													value: aux_responsable[0].id
												}],
												state_object: {
													value: 1,
													labelEn: "Pending approval",
													labelPt: "Pendente de aprovação"
												},
												deadline: '',
											}

											reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

											return

											let mail_content = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + '; border:1px solid transparent; border-collapse:collapse;">' +
												'<tr style="border-collapse: collapse;">' +
												'<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span><b>' + language[lang].notification_aproval_subject + '</b></span>' +
												'</div>' +
												'</td>' +
												'<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span>' + today_aux + '</span>' +
												'</div>' +
												'</td>' +
												'</tr>' +

												'<tr>' +
												'<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
												'</tr>' +

												'<tr style="border-collapse: collapse;">' +
												'<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<br/>' +
												'<span>' + language[lang].notification_aproval_text + '</span>' +
												'<br/>' +
												'</div>' +
												'</td>' +
												'</tr>' +
												'</table>'

											// let sendFrom = 'web.dev@assec.pt'
											// let sendTo = ['web.teste@assec.pt']
											// let sendToCC = ['web.dev@assec.pt']
											// let subject = language[lang].notification_aproval_subject
											// let content = mail_content
											// let attachment = []

											// await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)
										}

									}
								}
								if (notify_responsable_remove) {
									if (dados.current.info.responsable.remove.id !== '') {
										// let aux_id = dados.current.info.responsable.remove.id
										// let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										// console.log('remove aux_responsable', aux_responsable)
										dados.current.info.responsable.remove.notification = today
									}
								}

							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		}
		else {

			await Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						dados.current.info['uniqid'] = uid

						if (notify_responsable_edit) {
							if (dados.current.info.responsable.edit.id !== '') {
								let aux_id = dados.current.info.responsable.edit.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.edit.notification = today
								dados.current.info.responsable.edit.execution = today

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})

									// dados.current.info.responsable.aproval.id = ''
									// dados.current.info.responsable.aproval.name = ''
									// dados.current.info.responsable.aproval.notification = ''
									// dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
									}
									else {
										dados.current.info.historic.push({
											edit: {
												id: aux_responsable[0].id,
												name: aux_responsable[0].label,
												date: today
											},
											aproval: {
												id: '',
												name: '',
												date: ''
											}
										})

										dados.current.info.settings.document_state = "1"

										// dados.current.info.responsable.aproval.id = ''
										// dados.current.info.responsable.aproval.name = ''
										// dados.current.info.responsable.aproval.notification = ''
										// dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.aproval.notification = today

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados.current.info.responsable.remove.id !== '') {

								dados.current.info.responsable.remove.notification = today
								dados.current.info.responsable.remove.execution = today

							}

						}

						for await (let el_doc of files_doc_pdf) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf([])
						set_files_doc_pdf_name([])

						for await (let el_doc of files_doc_editable) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_editable([])
						set_files_doc_editable_name([])

						for await (let el_doc of files_doc_pdf_fatura) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'fatura', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_fatura([])
						set_files_doc_pdf_fatura_name([])

						for await (let el_doc of files_doc_pdf_garantia) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'garantia', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_garantia([])
						set_files_doc_pdf_garantia_name([])

						for await (let el_doc of files_doc_pdf_manual) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'manual', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_manual([])
						set_files_doc_pdf_manual_name([])

						for await (let el_doc of files_doc_pdf_rmm) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf_rmm', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf_rmm([])
						set_files_doc_pdf_rmm_name([])

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}

		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route, { id: dados.current.id })
						.then(() => {
							props.history.push(endpoints.list);
						})
						.catch(error => console.log(error))
				}
			})
			.catch((erro) => {
				console.log(erro)
			})

	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang } = dataset

		if (name === 'name' && 0) {
			let value_aux = {}
			let aux = dados.current.info.name.filter(e => e[lang])
			if (aux !== undefined && aux.length === 0) {
				value_aux[lang] = value
				dados.current.info.name.push(value_aux)
			}
			else {
				dados.current.info.name.forEach(el => {
					if (el[lang] !== undefined) {
						el[lang] = value
					}
				})
			}
		}

		dados.current.info[name] = value

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))


	}

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if (dados.current.info[name] === undefined) {
			dados.current.info[name] = []
		}

		let value_aux = {}
		let aux = dados.current.info[name].filter(e => e[lang])
		if (aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.info[name].push(value_aux)
		}
		else {
			dados.current.info[name].forEach(el => {
				if (el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		if (name === 'title' && parseInt(langid) === 1) {
			dados.current.info.name = value
		}

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvaiable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.avaiable = !dados.current.info.avaiable)
	}

	const handleSingleCheckAproval = () => {

		set_document_state_aprove(!document_state_aprove)

	}

	const handleSingleCheckRMM = () => {

		if(dados?.current?.info?.settings?.rmm === undefined || dados?.current?.info?.settings?.rmm == null) {
			dados.current.info.settings.rmm = false
		}

		set_dados(dados.current.info.settings.rmm = !dados.current.info.settings.rmm)

	}

	const handleSingleCheckPRM = () => {

		if(dados?.current?.info?.settings?.prm === undefined || dados?.current?.info?.settings?.prm == null) {
			dados.current.info.settings.prm = false
		}

		set_dados(dados.current.info.settings.prm = !dados.current.info.settings.prm)

	}

	const change_active_settings = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.settings === undefined) {
			dados.current.info.settings = {}
		}

		set_dados(dados.current.info.settings[name] = value)

		console.log('dados.current.info.settings', dados.current.info.settings)

	}

	const change_active_responsable = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.responsable === undefined) {
			dados.current.info.responsable = {}
		}

		if (name === 'edit') {
			set_notify_responsable_edit(true)
		}
		else if (name === 'aproval') {
			set_notify_responsable_aproval(true)
		}
		else if (name === 'remove') {
			set_notify_responsable_remove(true)
		}

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: value,
			name: '',
			notification: '',
			execution: ''
		}
		if (Array.isArray(aux_entity) && aux_entity.length > 0) {
			console.log(aux_entity[0])
			aux.name = aux_entity[0].label
		}

		set_dados(dados.current.info.responsable[name] = aux)

		console.log('dados.current.info.responsable', dados.current.info.responsable)

	}

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const handle_change_tree_editable = (tD, order, langid) => {

		treeDataEditable[order][langid] = tD

		let aux = []
		treeDataEditable[order][langid].forEach((el) => {
			dados.current.info.file.editable.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.editable = aux)
		setTreeDataEditable(treeDataEditable)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_editable = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataEditable[order][langid].filter(v => v.id !== id)
					treeDataEditable[order][langid] = treeAux
					setTreeDataEditable(treeDataEditable)

					let aux = []
					dados.current.info.file.editable.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.editable = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_editable = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataEditable[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.editable.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataEditable(treeDataEditable)
		set_dados(dados.current.info,)
	}

	const onChangeHandlerFilesEditable = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_editable_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_editable_name(aux2)

				let aux_doc = treeDataEditable
				if (treeDataEditable[order] === undefined)
					treeDataEditable[order] = []
				if (treeDataEditable[order][langid] === undefined)
					treeDataEditable[order][langid] = []
				let i = treeDataEditable[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataEditable(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_editable
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_editable(files_aux)
	}

	const handle_change_tree_pdf = (tD, order, langid) => {

		treeDataPDF[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}
		else {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDF[order][langid].filter(v => v.id !== id)
					treeDataPDF[order][langid] = treeAux
					setTreeDataPDF(treeDataPDF)

					let aux = []
					if (langid === '1') {
						dados.current.content[order].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order].media.doc = aux)
					}
					else {
						dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
					}

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDF[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDF(treeDataPDF)
		set_dados(dados.current.content[order],)
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_name(aux2)

				let aux_doc = treeDataPDF
				if (treeDataPDF[order] === undefined)
					treeDataPDF[order] = []
				if (treeDataPDF[order][langid] === undefined)
					treeDataPDF[order][langid] = []
				let i = treeDataPDF[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDF(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf(files_aux)
	}

	const handle_change_tree_pdf_fatura = (tD, order, langid) => {

		treeDataPDFFatura[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDFFatura[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDFFatura)
		}
		else {
			treeDataPDFFatura[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDFFatura(treeDataPDFFatura)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf_fatura = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDFFatura[order][langid].filter(v => v.id !== id)
					treeDataPDFFatura[order][langid] = treeAux
					setTreeDataPDFFatura(treeDataPDFFatura)

					let aux = []
					dados.current.info.file.fatura.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.fatura = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf_fatura = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDFFatura[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.fatura.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDFFatura(treeDataPDFFatura)
		set_dados(dados.current.content[order],)
	}

	const onChangeHandlerFilesPDFFatura = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_fatura_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_fatura_name(aux2)

				let aux_doc = treeDataPDFFatura
				if (treeDataPDFFatura[order] === undefined)
					treeDataPDFFatura[order] = []
				if (treeDataPDFFatura[order][langid] === undefined)
					treeDataPDFFatura[order][langid] = []
				let i = treeDataPDFFatura[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDFFatura(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf_fatura
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf_fatura(files_aux)
	}

	const handle_change_tree_pdf_garantia = (tD, order, langid) => {

		treeDataPDFGarantia[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDFGarantia[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDFGarantia)
		}
		else {
			treeDataPDFGarantia[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDFGarantia(treeDataPDFGarantia)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf_garantia = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDFGarantia[order][langid].filter(v => v.id !== id)
					treeDataPDFGarantia[order][langid] = treeAux
					setTreeDataPDFGarantia(treeDataPDFGarantia)

					let aux = []
					dados.current.info.file.garantia.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.garantia = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf_garantia = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDFGarantia[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.garantia.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDFGarantia(treeDataPDFGarantia)
		set_dados(dados.current.content[order],)
	}

	const onChangeHandlerFilesPDFGarantia = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_garantia_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_garantia_name(aux2)

				let aux_doc = treeDataPDFGarantia
				if (treeDataPDFGarantia[order] === undefined)
					treeDataPDFGarantia[order] = []
				if (treeDataPDFGarantia[order][langid] === undefined)
					treeDataPDFGarantia[order][langid] = []
				let i = treeDataPDFGarantia[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDFGarantia(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf_garantia
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf_garantia(files_aux)
	}

	const handle_change_tree_pdf_manual = (tD, order, langid) => {

		treeDataPDFManual[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDFManual[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDFManual)
		}
		else {
			treeDataPDFManual[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDFManual(treeDataPDFManual)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf_manual = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDFManual[order][langid].filter(v => v.id !== id)
					treeDataPDFManual[order][langid] = treeAux
					setTreeDataPDFManual(treeDataPDFManual)

					
					let aux = []
					dados.current.info.file.manual.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.manual = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf_manual = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDFManual[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.manual.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDFManual(treeDataPDFManual)
		set_dados(dados.current.content[order],)
	}

	const onChangeHandlerFilesPDFManual = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_manual_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_manual_name(aux2)

				let aux_doc = treeDataPDFManual
				if (treeDataPDFManual[order] === undefined)
					treeDataPDFManual[order] = []
				if (treeDataPDFManual[order][langid] === undefined)
					treeDataPDFManual[order][langid] = []
				let i = treeDataPDFManual[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDFManual(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf_manual
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf_manual(files_aux)
	}

	const handle_change_tree_pdf_rmm = (tD, order, langid) => {

		treeDataPDFRMM[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDFRMM[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDFRMM)
		}
		else {
			treeDataPDFRMM[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDFManual(treeDataPDFRMM)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf_rmm = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDFRMM[order][langid].filter(v => v.id !== id)
					treeDataPDFRMM[order][langid] = treeAux
					setTreeDataPDFRMM(treeDataPDFRMM)

					
					let aux = []
					dados.current.info.file.pdf_rmm.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.pdf_rmm = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf_rmm = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDFRMM[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.pdf_rmm.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDFRMM(treeDataPDFRMM)
		set_dados(dados.current.content[order],)
	}

	const onChangeHandlerFilesPDFRMM = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_rmm_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_rmm_name(aux2)

				let aux_doc = treeDataPDFRMM
				if (treeDataPDFRMM[order] === undefined)
					treeDataPDFRMM[order] = []
				if (treeDataPDFRMM[order][langid] === undefined)
					treeDataPDFRMM[order][langid] = []
				let i = treeDataPDFRMM[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDFRMM(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf_rmm
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf_rmm(files_aux)
	}

	const onChangeHandlerFilesPDFRMMCertificado = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				dados.current.info.historic_rmm.forEach(el => {

					// Order é o id do elemento no array historic_rmm

					if(parseInt(el.id) === parseInt(order)) {
						el.file.certificado['name'] = v.name
					}
				})
			
				setRefresh(r => r + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});


		console.log('dados.current.info.historic_rmm', dados.current.info.historic_rmm)

		let files_aux = files_doc_pdf_rmm_certificado
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf_rmm_certificado(files_aux)
	}

	const handle_change_tree_pdf_rmm_certificado = (tD, order, langid) => {

		treeDataPDFRMM[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDFRMM[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDFRMM)
		}
		else {
			treeDataPDFRMM[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDFManual(treeDataPDFRMM)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf_rmm_certificado = (idparent, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					
					let aux = []
					dados.current.info.historic_rmm.forEach((el) => {
						if (parseInt(el.id) === parseInt(idparent)) {
							el.file.certificado = {}
						}
						aux.push(el)
					})
					set_dados(dados.current.info.file.pdf_rmm = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf_rmm_certificado = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		let aux = []
		dados.current.info.historic_rmm.forEach((el) => {
			if (parseInt(el.id) === parseInt(order)) {
				el.file.certificado.name = value
			}
			aux.push(el)
		})
		set_dados(dados.current.info.file.pdf_rmm = aux)

	}

	const onChangeHandlerFilesPDFRMMAprovacao = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				dados.current.info.historic_rmm.forEach(el => {

					// Order é o id do elemento no array historic_rmm

					if(parseInt(el.id) === parseInt(order)) {
						el.file.aprovacao['name'] = v.name
					}
				})
			
				setRefresh(r => r + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});


		console.log('dados.current.info.historic_rmm', dados.current.info.historic_rmm)

		let files_aux = files_doc_pdf_rmm_aprovacao
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf_rmm_aprovacao(files_aux)
	}

	const handle_change_tree_pdf_rmm_aprovacao = (tD, order, langid) => {

		treeDataPDFRMM[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDFRMM[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDFRMM)
		}
		else {
			treeDataPDFRMM[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDFManual(treeDataPDFRMM)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf_rmm_aprovacao = (idparent, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					
					let aux = []
					dados.current.info.historic_rmm.forEach((el) => {
						if (parseInt(el.id) === parseInt(idparent)) {
							el.file.aprovacao = {}
						}
						aux.push(el)
					})
					set_dados(dados.current.info.file.pdf_rmm = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf_rmm_aprovacao = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		let aux = []
		dados.current.info.historic_rmm.forEach((el) => {
			if (parseInt(el.id) === parseInt(order)) {
				el.file.certificado.name = value
			}
			aux.push(el)
		})
		set_dados(dados.current.info.file.pdf_rmm = aux)

	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		for await (let element of files) {
			aux.push(element)

			await uploadFile(element, order, type, langid, lang)
		}
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'maintenance')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/maintenance/');

		let res = await reqFILE(`${api_crud_base}/multimedia/file`, formData)

		var today_file = new Date()
		let i = Date.now()

		if (dados.current.info.file === undefined) {
			dados.current.info.file = {}
		}
		if (!Array.isArray(dados.current.info.file[type])) {
			dados.current.info.file[type] = []
		}
		if (dados.current.info.file[type][0] == undefined || dados.current.info.file[type][0] === null) {
			dados.current.info.file[type].push({})
		}

		if (type === 'editable') {
			dados.current.info.file[type][0] = {
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			}
		}
		else if (type === 'pdf') {
			dados.current.info.file[type][0] = {
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			}
		}
		else if (type === 'fatura') {
			dados.current.info.file[type][0] = {
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			}
		}
		else if (type === 'garantia') {
			dados.current.info.file[type][0] = {
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			}
		}
		else if (type === 'manual') {
			dados.current.info.file[type][0] = {
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			}
		}
		else if (type === 'pdf_rmm') {
			dados.current.info.file[type][0] = {
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			}
		}
		else if (type === 'pdf_rmm_certificado') {

			// order é o ID do elemento no array historic_rmm

			dados.current.info.historic_rmm.forEach(el_rmm => {
				if(parseInt(el_rmm.id) === parseInt(order)) {
					el_rmm.file.certificado = {
						id: i,
						link: res.data.path + '/' + res.data.name,
						name: file.name,
						description: '',
						type: type,
						date: today_file,
						order: dados.current.info.file[type].length,
						lang: []
					}
				}
			})
		}
		else if (type === 'pdf_rmm_aprovacao') {

			// order é o ID do elemento no array historic_rmm

			dados.current.info.historic_rmm.forEach(el_rmm => {
				if(parseInt(el_rmm.id) === parseInt(order)) {
					el_rmm.file.aprovacao = {
						id: i,
						link: res.data.path + '/' + res.data.name,
						name: file.name,
						description: '',
						type: type,
						date: today_file,
						order: dados.current.info.file[type].length,
						lang: []
					}
				}
			})
		}

		await reqPUT(api_crud_route, dados.current)

		return true

	}

	const add_rmm = (type) => {

		if(dados?.current?.info?.historic_rmm === undefined) {
			dados.current.info.historic_rmm = []
		}

		set_dados(dados.current.info.historic_rmm.push({
			id: Date.now(),
			rmm_type: type,
			date: '',
			result: '',
			date_next: '',
			file: {
				certificado: {},
				aprovacao: {}
			}
		}))

		console.log('dados.current.info.historic_rmm', dados.current.info.historic_rmm)

	}

	const change_active_rmm = (e) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset

		if (dados?.current?.info?.historic_rmm === undefined) {
			dados.current.info.historic_rmm = []
		}

		let aux = dados.current.info.historic_rmm
		aux.forEach(el => {
			if(parseInt(el.id) === parseInt(id)) {
				el[name] = value
			}
		})
		set_dados(dados.current.info.historic_rmm = aux)

		setRefresh(r => r + 1)

		console.log('dados.current.info.historic_rmm', dados.current.info.historic_rmm)

	}

	const remove_rmm_historic = (id) => {

		let aux = []
		dados.current.info.historic_rmm.forEach(el => {
			if(parseInt(el.id) !== parseInt(id)) {
				aux.push(el)
			}
		})
		set_dados(dados.current.info.historic_rmm = aux)

		setRefresh(r => r + 1)
	}

	const get_type_name = (id) => {

		let result = ''		
		rmm_type.current.forEach(el => {
			if(parseInt(el.id) === parseInt(id)) {
				result = el.label
			}
		})

		return result

	}

	return isloading ?
		<Loader />
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<div className="container">
						<h2 className="dash-title">{language[lang].component}</h2>
						<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
					</div>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className='card'>
									<div className="card-header border-0 d-flex justify-content-sm-between">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
												content_language.length > 1 ?
													content_language.map((el_lang, k_lang) => {
														return (
															<li key={k_lang} className="nav-item d-none">
																<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
															</li>
														)
													})
												:
													null
												}
											</ul>
										</div>
									</div>

									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
														content_language.length > 0 ?
															content_language.map((el_lang, k_lang) => {
																return (
																	<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">

																		<div className='row mb-4'>
																			<div className="col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].field_active_type}</label>
																				<select
																					name="active_type"
																					className="form-select form-control mb-4 mb-lg-0 rounded-0"
																					onChange={change_active_settings}
																					value={dados?.current?.info?.settings?.active_type !== undefined && dados?.current?.info?.settings?.active_type !== null ? dados.current.info.settings.active_type : ''}
																				>
																					<option value="">{language[lang].field_choose}</option>
																					{
																					active_type.current !== undefined && active_type.current !== null ?
																						active_type.current.map((el_dt, k_dt) => (
																							<option key={k_dt} value={el_dt.id}>
																								{el_dt.label}
																							</option>
																						))
																					:
																						null
																					}
																				</select>
																			</div>

																			<div className="col-4 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].field_equip_state}</label>
																				<select
																					name="active_state"
																					className="form-select form-control mb-4 mb-lg-0 rounded-0"
																					onChange={change_active_settings}
																					value={dados?.current?.info?.settings?.active_state !== undefined && dados?.current?.info?.settings?.active_state !== null ? dados.current.info.settings.active_state : ''}
																				>
																					<option value="">{language[lang].field_choose}</option>
																					{
																						active_state.current !== undefined && active_state.current !== null ?
																							active_state.current.map((el_dsl, k_dsl) => (
																								<option key={k_dsl} value={el_dsl.id}>
																									{el_dsl.label}
																								</option>
																							))
																							:
																							null
																					}
																				</select>
																			</div>

																			{/* Responsável de Aprovação */
																				dados?.current?.info?.settings?.active_state !== undefined && dados?.current?.info?.settings?.active_state !== null &&
																					parseInt(dados?.current?.info?.settings?.active_state) === 1 && parseInt(dados.current.info.responsable.aproval.id) === parseInt(getTokenInfo().id) ?
																					<div className="col-2">
																						<div className="d-flex">
																							<div className="ms-3">
																								<label className="fs-6 fw-bold mb-2">{language[lang].field_aproval}</label>
																								<div className="input-group">
																									<label className="switch">
																										<input
																											id={'item-switch-aproval'}
																											name={"aproval"}
																											className=""
																											type="checkbox"
																											value={dados.current.info.settings.active_state !== undefined && parseInt(dados.current.info.settings.active_state) === 3 ? true : false}
																											onChange={handleSingleCheckAproval}
																											defaultChecked={dados.current.info.settings.active_state !== undefined && parseInt(dados.current.info.settings.active_state) === 3 ? true : false}
																										/>
																										<span className="slider" htmlFor={'item-switch-aproval'}></span>
																									</label>
																								</div>
																							</div>
																						</div>
																					</div>
																					:
																					null
																			}
																		</div>

																		<div className='row mb-4'>
																			<div className="col-2">
																				<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_tag}</label>
																				<input
																					type="text"
																					name="tag"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.tag}
																					onChange={(e) => handle_change_info(e)}
																					className="form-control rounded-0" />
																			</div>
																			<div className="col-6">
																				<label
																					className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>
																					{language[lang].field_name}
																					{k_lang > 0 ? '(' + el_lang.code + ')' : ''}
																				</label>
																				<input type="text" name="title" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.title, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" required={el_lang.id === '1' ? 'required' : ''} />
																			</div>

																			{
																				el_lang.id === '1' || true ?
																					<div className="col-2">
																						<div className="d-flex">
																							<div className="mb-3 d-none">
																								<label className="fs-6 fw-bold mb-2">{language[lang].field_activo}</label>
																								<div className="input-group">
																									<label className="switch">
																										<input
																											id={'item-switch-active'}
																											name={"active"}
																											className=""
																											type="checkbox"
																											value={dados.current.info.active}
																											onChange={handleSingleCheckActive}
																											defaultChecked={dados.current.info.active}
																										/>
																										<span className="slider" htmlFor={'item-switch-active'}></span>
																									</label>
																								</div>
																							</div>

																							<div className="ms-3">
																								<label className="fs-6 fw-bold mb-2">{language[lang].field_avaiable}</label>
																								<div className="input-group">
																									<label className="switch">
																										<input
																											id={'item-switch-avaiable'}
																											name={"avaiable"}
																											className=""
																											type="checkbox"
																											value={dados.current.info.avaiable}
																											onChange={handleSingleCheckAvaiable}
																											defaultChecked={dados.current.info.avaiable}
																										/>
																										<span className="slider" htmlFor={'item-switch-avaiable'}></span>
																									</label>
																								</div>
																							</div>

																						</div>
																					</div>
																					:
																					null
																			}
																		</div>

																		<div className="row mb-4">
																			<div className="col-6">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																				<textarea
																					type="text"
																					rows="4"
																					name="description"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={translate(dados.current.info.description, el_lang.code)}
																					onChange={(e) => handle_change_info_translate(e)}
																					className="form-control rounded-0"
																				/>
																			</div>
																		</div>

																		<div className="row mb-4">
																			<div className="col-4 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_storage_brand}</label>
																				<input
																					type="text"
																					name="storage_brand"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.settings.storage_brand}
																					placeholder={language[lang].field_storage_brand_placeholder}
																					onChange={(e) => change_active_settings(e)}
																					className="form-control rounded-0" />
																			</div>

																			<div className="col-4 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_storage_model}</label>
																				<input
																					type="text"
																					name="storage_model"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.settings.storage_model}
																					placeholder={language[lang].field_storage_model_placeholder}
																					onChange={(e) => change_active_settings(e)}
																					className="form-control rounded-0" />
																			</div>
																		</div>

																		<div className="row mb-4">
																			<div className="col-4 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_storage_serie}</label>
																				<input
																					type="text"
																					name="storage_serie"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.settings.storage_serie}
																					placeholder={language[lang].field_storage_serie_placeholder}
																					onChange={(e) => change_active_settings(e)}
																					className="form-control rounded-0" />
																			</div>

																			<div className="col-4 col-md-2">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_storage_fab_year}</label>
																				<input
																					type="text"
																					name="storage_fab_year"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.settings.storage_fab_year}
																					onChange={(e) => change_active_settings(e)}
																					className="form-control rounded-0 text-end" />
																			</div>
																		</div>

																		<div className='row mb-4'>
																			{/*
																			<div className="col-4 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].field_storage_type}</label>
																				<select
																					name="storage_type"
																					className="form-select form-control mb-4 mb-lg-0 rounded-0"
																					onChange={change_active_settings}
																					value={dados?.current?.info?.settings?.storage_type !== undefined && dados?.current?.info?.settings?.storage_type !== null ? dados.current.info.settings.storage_type : ''}
																				>
																					<option value="">{language[lang].field_choose}</option>
																					{
																					storage_type.current !== undefined && storage_type.current !== null ?
																						storage_type.current.map((el_st, k_st) => (
																							<option key={k_st} value={el_st.id}>
																								{el_st.label}
																							</option>
																						))
																					:
																						null
																					}
																				</select>
																			</div>
																			*/}

																			<div className="col-4 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_storage_supply}</label>
																				<input
																					type="text"
																					name="storage_supply"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.settings.storage_supply}
																					onChange={(e) => change_active_settings(e)}
																					className="form-control rounded-0" />
																			</div>

																			<div className="col-4 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_storage_local}</label>
																				<input
																					type="text"
																					name="storage_local"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.settings.storage_local}
																					onChange={(e) => change_active_settings(e)}
																					className="form-control rounded-0" />
																			</div>

																			{/*
																			<div className="col-4 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].field_active_state}</label>
																				<select
																					name="active_state"
																					className="form-select form-control mb-4 mb-lg-0 rounded-0"
																					onChange={change_active_settings}
																					value={dados?.current?.info?.settings?.active_state !== undefined && dados?.current?.info?.settings?.active_state !== null ? dados.current.info.settings.active_state : ''}
																				>
																					<option value="">{language[lang].field_choose}</option>
																					{
																						active_state.current !== undefined && active_state.current !== null ?
																							active_state.current.map((el_rt, k_rt) => (
																								<option key={k_rt} value={el_rt.id}>
																									{el_rt.label}
																								</option>
																							))
																							:
																							null
																					}
																				</select>
																			</div>
 																		*/}

																		</div>

																		< br />

																		<div className="row mb-4">
																			<h3 className="fw-bolder mb-3">{language[lang].informacao_financeira}</h3>
																			<div className="card-body border-top p-4"></div>

																			<div className="col-4 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].ano_de_aquisicao}</label>
																				<input
																					type="date"
																					name="ano_de_aquisicao"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.settings.ano_de_aquisicao}
																					onChange={(e) => change_active_settings(e)}
																					className="form-control rounded-0" />
																			</div>

																			<div className="col-4 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].valor_de_aquisicao}</label>
																				<div className="input-group">
																					<input 
																						type="text"
																						name="valor_de_aquisicao"
																						data-langid={el_lang.id}
																						data-lang={el_lang.code}
																						defaultValue={dados.current.info.settings.valor_de_aquisicao}
																						placeholder={language[lang].valor_de_aquisicao_placeholder}
																						onChange={(e) => change_active_settings(e)}
																						className="form-control rounded-0 text-end" 
																					/>
																					<span className='input-group-text rounded-0'>&euro;</span>
																				</div>
																			</div>
																		</div>

																		<div className="row mb-4">
																			<div className="col-4 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].data_fim_de_garantia}</label>
																				<input
																					type="date"
																					name="data_fim_de_garantia"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.settings.data_fim_de_garantia}
																					onChange={(e) => change_active_settings(e)}
																					className="form-control rounded-0" />
																			</div>
																			<div className="col-4 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].data_fim_de_vida}</label>
																				<input
																					type="date"
																					name="data_fim_de_vida"
																					data-langid={el_lang.id}
																					data-lang={el_lang.code}
																					defaultValue={dados.current.info.settings.data_fim_de_vida}
																					onChange={(e) => change_active_settings(e)}
																					className="form-control rounded-0" />
																			</div>
																		</div>

																		<div className="row mb-4 d-none">
																			<div className="col-12 col-md-6">
																				<div className="div-doc">
																					<label className="col-form-label fw-bold fs-6">{language[lang].editable_documents}</label>

																					<div className="dropzone-panel mb-lg-0 mb-2">
																						<div className="div-form-input col-12 custom-file">
																							<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-editable-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																							<input
																								id={"input-files-editable-" + 0 + '-' + el_lang.id}
																								type="file"
																								// accept="application/pdf"
																								data-order={0}
																								data-langid={el_lang.id}
																								data-lang={el_lang.code}
																								data-type={'doc'}
																								className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																								onChange={onChangeHandlerFilesEditable}
																								multiple
																							/>
																						</div>
																					</div>

																					<div className="row">
																						{
																							treeDataEditable[0] !== undefined && treeDataEditable[0][el_lang.id] !== undefined ?
																								<SortableTree
																									isVirtualized={false}
																									treeData={treeDataEditable[0][el_lang.id]}
																									maxDepth={1}
																									canDrag={false}
																									//onChange={() => console.log('onChange')}
																									onChange={treeDataEditable => handle_change_tree_editable(treeDataEditable, 0, el_lang.id)}
																									getNodeKey={({ node }) => node.id}
																									generateNodeProps={extendedNode => ({
																										title: (
																											<>
																												{extendedNode.node.title}
																												<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_editable} />
																											</>
																										),
																										buttons: [
																											<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																											<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																											<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																											<button type="button" onClick={() => remove_element_tree_editable(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																										],
																									})}
																								/>
																								:
																								''
																						}
																					</div>
																				</div>
																			</div>

																			<div className="col-12 col-md-6">
																				<div className="div-doc">
																					<label className="col-form-label fw-bold fs-6">{language[lang].pdf_documents}</label>

																					<div className="dropzone-panel mb-lg-0 mb-2">
																						<div className="div-form-input col-12 custom-file">
																							<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																							<input
																								id={"input-files-pdf-" + 0 + '-' + el_lang.id}
																								type="file"
																								accept="application/pdf"
																								data-order={0}
																								data-langid={el_lang.id}
																								data-lang={el_lang.code}
																								data-type={'doc'}
																								className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																								onChange={onChangeHandlerFilesPDF}
																								multiple
																							/>
																						</div>
																					</div>

																					<div className="row">
																						{
																							treeDataPDF[0] !== undefined && treeDataPDF[0][el_lang.id] !== undefined ?
																								<SortableTree
																									isVirtualized={false}
																									treeData={treeDataPDF[0][el_lang.id]}
																									maxDepth={1}
																									canDrag={false}
																									//onChange={() => console.log('onChange')}
																									onChange={treeDataPDF => handle_change_tree_pdf(treeDataPDF, 0, el_lang.id)}
																									getNodeKey={({ node }) => node.id}
																									generateNodeProps={extendedNode => ({
																										title: (
																											<>
																												<span>{extendedNode.node.title}</span>
																												<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf} />
																											</>
																										),
																										buttons: [
																											<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																											<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																											<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																											<button type="button" onClick={() => remove_element_tree_pdf(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																										],
																									})}
																								/>
																								:
																								''
																						}
																					</div>
																				</div>
																			</div>
																		</div>

																		<div className="row mb-4">
																			<div className="col-12 col-md-4">
																				<div className="div-doc">
																					<label className="col-form-label fw-bold fs-6">{language[lang].pdf_fatura}</label>

																					<div className="dropzone-panel mb-lg-0 mb-2">
																						<div className="div-form-input col-12 custom-file">
																							<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-fatura-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																							<input
																								id={"input-files-fatura-" + 0 + '-' + el_lang.id}
																								type="file"
																								accept="application/pdf"
																								data-order={0}
																								data-langid={el_lang.id}
																								data-lang={el_lang.code}
																								data-type={'doc'}
																								className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																								onChange={onChangeHandlerFilesPDFFatura}
																								multiple
																							/>
																						</div>
																					</div>

																					<div className="row">
																						{
																							treeDataPDFFatura[0] !== undefined && treeDataPDFFatura[0][el_lang.id] !== undefined ?
																								<SortableTree
																									isVirtualized={false}
																									treeData={treeDataPDFFatura[0][el_lang.id]}
																									maxDepth={1}
																									canDrag={false}
																									//onChange={() => console.log('onChange')}
																									onChange={treeDataPDFFatura => handle_change_tree_pdf_fatura(treeDataPDFFatura, 0, el_lang.id)}
																									getNodeKey={({ node }) => node.id}
																									generateNodeProps={extendedNode => ({
																										title: (
																											<>
																												<span>{extendedNode.node.title}</span>
																												<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf_fatura} />
																											</>
																										),
																										buttons: [
																											<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																											<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																											<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																											<button type="button" onClick={() => remove_element_tree_pdf_fatura(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																										],
																									})}
																								/>
																								:
																								''
																						}
																					</div>
																				</div>
																			</div>
																			<div className="col-12 col-md-4">
																				<div className="div-doc">
																					<label className="col-form-label fw-bold fs-6">{language[lang].pdf_garantia}</label>

																					<div className="dropzone-panel mb-lg-0 mb-2">
																						<div className="div-form-input col-12 custom-file">
																							<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-garantia-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																							<input
																								id={"input-files-garantia-" + 0 + '-' + el_lang.id}
																								type="file"
																								accept="application/pdf"
																								data-order={0}
																								data-langid={el_lang.id}
																								data-lang={el_lang.code}
																								data-type={'doc'}
																								className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																								onChange={onChangeHandlerFilesPDFGarantia}
																								multiple
																							/>
																						</div>
																					</div>

																					<div className="row">
																						{
																							treeDataPDFGarantia[0] !== undefined && treeDataPDFGarantia[0][el_lang.id] !== undefined ?
																								<SortableTree
																									isVirtualized={false}
																									treeData={treeDataPDFGarantia[0][el_lang.id]}
																									maxDepth={1}
																									canDrag={false}
																									//onChange={() => console.log('onChange')}
																									onChange={treeDataPDFGarantia => handle_change_tree_pdf_fatura(treeDataPDFGarantia, 0, el_lang.id)}
																									getNodeKey={({ node }) => node.id}
																									generateNodeProps={extendedNode => ({
																										title: (
																											<>
																												<span>{extendedNode.node.title}</span>
																												<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf_garantia} />
																											</>
																										),
																										buttons: [
																											<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																											<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																											<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																											<button type="button" onClick={() => remove_element_tree_pdf_garantia(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																										],
																									})}
																								/>
																								:
																								''
																						}
																					</div>
																				</div>
																			</div>
																			<div className="col-12 col-md-4">
																				<div className="div-doc">
																					<label className="col-form-label fw-bold fs-6">{language[lang].pdf_manual}</label>

																					<div className="dropzone-panel mb-lg-0 mb-2">
																						<div className="div-form-input col-12 custom-file">
																							<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-manual-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																							<input
																								id={"input-files-manual-" + 0 + '-' + el_lang.id}
																								type="file"
																								accept="application/pdf"
																								data-order={0}
																								data-langid={el_lang.id}
																								data-lang={el_lang.code}
																								data-type={'doc'}
																								className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																								onChange={onChangeHandlerFilesPDFManual}
																								multiple
																							/>
																						</div>
																					</div>

																					<div className="row">
																						{
																							treeDataPDFManual[0] !== undefined && treeDataPDFManual[0][el_lang.id] !== undefined ?
																								<SortableTree
																									isVirtualized={false}
																									treeData={treeDataPDFManual[0][el_lang.id]}
																									maxDepth={1}
																									canDrag={false}
																									//onChange={() => console.log('onChange')}
																									onChange={treeDataPDFManual => handle_change_tree_pdf_fatura(treeDataPDFManual, 0, el_lang.id)}
																									getNodeKey={({ node }) => node.id}
																									generateNodeProps={extendedNode => ({
																										title: (
																											<>
																												<span>{extendedNode.node.title}</span>
																												<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf_manual} />
																											</>
																										),
																										buttons: [
																											<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																											<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																											<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																											<button type="button" onClick={() => remove_element_tree_pdf_manual(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																										],
																									})}
																								/>
																								:
																								''
																						}
																					</div>
																				</div>
																			</div>
																		</div>
																		
																		<div className='row mb-4'>
																			<div className="col-6">
																				<div className="d-flex">
																					<div className="me-3">
																						<label className="fs-6 fw-bold mb-2">{language[lang].field_rmm}</label>
																						<div className="input-group">
																							<label className="switch">
																								<input
																									id={'item-switch-rmm'}
																									name={"rmm"}
																									className=""
																									type="checkbox"
																									value={dados.current.info.settings.rmm !== undefined && dados.current.info.settings.rmm === true ? true : false}
																									onChange={handleSingleCheckRMM}
																									defaultChecked={dados.current.info.settings.rmm !== undefined && dados.current.info.settings.rmm === true ? true : false}
																								/>
																								<span className="slider" htmlFor={'item-switch-rmm'}></span>
																							</label>
																						</div>
																					</div>
																					<div className="me-3">
																						<label className="fs-6 fw-bold mb-2">{language[lang].field_prm}</label>
																						<div className="input-group">
																							<label className="switch">
																								<input
																									id={'item-switch-prm'}
																									name={"prm"}
																									className=""
																									type="checkbox"
																									value={dados.current.info.settings.prm !== undefined && dados.current.info.settings.prm === true ? true : false}
																									onChange={handleSingleCheckPRM}
																									defaultChecked={dados.current.info.settings.prm !== undefined && dados.current.info.settings.prm === true ? true : false}
																								/>
																								<span className="slider" htmlFor={'item-switch-prm'}></span>
																							</label>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>

																	</div>
																)
															})
															:
															null
													}
												</div>
											</div>

											{
											dados.current.info.settings.rmm !== undefined && dados.current.info.settings.rmm !== null && dados.current.info.settings.rmm === true ?
												<div className="card-body border-top p-4">

													<div className="row mb-4">
														<div className="col-4 col-md-3">
															<label className="fs-6 fw-bold mb-2">{language[lang].field_type}</label>
															<select
																name="rmm_type"
																className="form-select form-control mb-4 mb-lg-0 rounded-0"
																onChange={change_active_settings}
																value={dados?.current?.info?.settings?.rmm_type !== undefined && dados?.current?.info?.settings?.rmm_type !== null ? dados.current.info.settings.rmm_type : ''}
															>
																<option value="">{language[lang].field_choose}</option>
																{
																	rmm_type.current !== undefined && rmm_type.current !== null ?
																		rmm_type.current.map((el_dt, k_dt) => (
																			<option key={k_dt} value={el_dt.id}>
																				{el_dt.label}
																			</option>
																		))
																		:
																		null
																}
															</select>
														</div>
														<div className="col-4 col-md-3">
															<label className={"fs-6 fw-bold mb-2"}>{language[lang].periodicity}</label>
															<input
																type="text"
																name="rmm_periodicity"
																value={dados.current.info.settings.rmm_periodicity}
																onChange={(e) => change_active_settings(e)}
																className="form-control rounded-0" />
														</div>
													</div>

													{
													dados?.current?.info?.settings?.rmm_type !== undefined && dados?.current?.info?.settings?.rmm_type !== null && dados.current.info.settings.rmm_type !== '' ?
														<div className='row mb-4'>
															<div className='col-12 text-end'>
																<button type="button" className='btn btn-sm btn-secondary rounded-0 me-2' onClick={() => add_rmm(dados.current.info.settings.rmm_type)}>{language[lang].add_rmm} {get_type_name(dados.current.info.settings.rmm_type)}</button>
															</div>
														</div>
													:
														null
													}
													{
													Array.isArray(dados.current.info.historic_rmm) && dados.current.info.historic_rmm.length > 0 ?
														<div className='row mb-4'>	
															<h3 className='fw-bolder m-3'>{language[lang].rmm}</h3>		
															<div className="accordion border-0" id="accordionActionsHistoricRMM">
																{
																dados.current.info.historic_rmm ?
																	dados.current.info.historic_rmm.map((rmm_el, rmm_key) => {
																		return (
																			<div key={rmm_key} className="accordion-item border-0 border-bottom">
																				<h2 className="accordion-header">
																					<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse_h_rmm_" + rmm_key} aria-expanded="true" aria-controls={"collapse_h_rmm_" + rmm_key}>
																						{get_type_name(dados.current.info.settings.rmm_type)} { (rmm_key + 1) } { rmm_el?.date !== undefined ? ' - ' + rmm_el.date : '' }
																					</button>
																				</h2>
																				<div id={"collapse_h_rmm_" + rmm_key} className="accordion-collapse collapse p-3" data-bs-parent="#accordionActionsHistoricRMM">
																					<div className="row mb-4 p">
																						<div className="col-12 text-end">
																							<button type="button" className="btn btn-sm btn-danger rounded-0" onClick={() => remove_rmm_historic(rmm_el.id)}><i className="bi bi-x-lg"></i></button>
																						</div>
																						<div className="col-4 col-md-3">
																							<label className={"fs-6 fw-bold mb-2"}>{language[lang].date_execution}</label>
																							<input
																								type="date"
																								name="date"
																								data-id={rmm_el.id}
																								value={rmm_el.date}
																								onChange={(e) => change_active_rmm(e)}
																								className="form-control rounded-0" />
																						</div>
																						<div className="col-4 col-md-3">
																							<label className={"fs-6 fw-bold mb-2"}>{language[lang].result}</label>
																							<input
																								type="text"
																								name="result"
																								data-id={rmm_el.id}
																								value={rmm_el.result}
																								onChange={(e) => change_active_rmm(e)}
																								className="form-control rounded-0" />
																						</div>
																						<div className="col-4 col-md-3">
																							<label className={"fs-6 fw-bold mb-2"}>{language[lang].next_verification}</label>
																							<input
																								type="date"
																								name="date_next"
																								data-id={rmm_el.id}
																								value={rmm_el.date_next}
																								onChange={(e) => change_active_rmm(e)}
																								className="form-control rounded-0" />
																						</div>

																						<div className='col-12'></div>
																						
																						<div className="col-12 d-none col-md-4 my-3">
																							<div className="div-doc">
																								<label className="col-form-label fw-bold fs-6">{language[lang].pdf_rmm}</label>

																								<div className="dropzone-panel mb-lg-0 mb-2">
																									<div className="div-form-input col-12 custom-file">
																										<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-rmm-" + 0 + '-' + 1}>{language[lang].doc_choose}</label>
																										<input
																											id={"input-files-rmm-" + 0 + '-' + 1}
																											type="file"
																											accept="application/pdf"
																											data-order={0}
																											data-langid={1}
																											data-lang={'pt'}
																											data-type={'doc'}
																											className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																											onChange={onChangeHandlerFilesPDFRMM}
																											multiple
																										/>
																									</div>
																								</div>

																								<div className="row">
																									{
																										treeDataPDFRMM[0] !== undefined && treeDataPDFRMM[0][1] !== undefined ?
																											<SortableTree
																												isVirtualized={false}
																												treeData={treeDataPDFRMM[0][1]}
																												maxDepth={1}
																												canDrag={false}
																												//onChange={() => console.log('onChange')}
																												onChange={treeDataPDFRMM => handle_change_tree_pdf_fatura(treeDataPDFRMM, 0, 1)}
																												getNodeKey={({ node }) => node.id}
																												generateNodeProps={extendedNode => ({
																													title: (
																														<>
																															<span>{extendedNode.node.title}</span>
																															<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf_rmm} />
																														</>
																													),
																													buttons: [
																														<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																														<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																														<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																														<button type="button" onClick={() => remove_element_tree_pdf_rmm(0, 1, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																													],
																												})}
																											/>
																											:
																											''
																									}
																								</div>
																							</div>
																						</div>
																						
																						<div className="col-6 col-md-4 my-3">
																							<div className="div-doc">
																								<label className="col-form-label fw-bold fs-6">{language[lang].pdf_rmm_certificado}</label>

																								<div className="dropzone-panel mb-lg-0 mb-2">
																									<div className="div-form-input col-12 custom-file">
																										<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-rmm-certificado-" + 0 + '-' + 1}>{language[lang].doc_choose}</label>
																										<input
																											id={"input-files-rmm-certificado-" + 0 + '-' + 1}
																											type="file"
																											accept="application/pdf"
																											data-order={rmm_el.id}
																											data-langid={1}
																											data-lang={'pt'}
																											data-type={'doc'}
																											className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																											onChange={onChangeHandlerFilesPDFRMMCertificado}
																										/>
																									</div>
																								</div>

																								<div className="row">
																									{
																									rmm_el?.file?.certificado?.name !== undefined && rmm_el.file.certificado.name !== '' ?
																										<SortableTree
																											isVirtualized={false}
																											treeData={[{ id: 1, id_doc: '', title: rmm_el.file.certificado.name, link: rmm_el.file.certificado.link, visible: true }]}
																											maxDepth={1}
																											canDrag={false}
																											//onChange={() => console.log('onChange')}
																											onChange={() => {}}
																											getNodeKey={({ node }) => node.id}
																											generateNodeProps={extendedNode => ({
																												title: (
																													<>
																														<span>{extendedNode.node.title}</span>
																														<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={rmm_el.id} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf_rmm_certificado} />
																													</>
																												),
																												buttons: [
																													<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																													<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																													<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																													<button type="button" onClick={() => remove_element_tree_pdf_rmm_certificado(rmm_el.id, 1, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																												],
																											})}
																										/>
																									:
																										null
																									}
																								</div>
																							</div>
																						</div>
																						
																						<div className="col-6 col-md-4 my-3">
																							<div className="div-doc">
																								<label className="col-form-label fw-bold fs-6">{language[lang].pdf_rmm_aprovacao}</label>

																								<div className="dropzone-panel mb-lg-0 mb-2">
																									<div className="div-form-input col-12 custom-file">
																										<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-rmm-aprovacao-" + 0 + '-' + 1}>{language[lang].doc_choose}</label>
																										<input
																											id={"input-files-rmm-aprovacao-" + 0 + '-' + 1}
																											type="file"
																											accept="application/pdf"
																											data-order={rmm_el.id}
																											data-langid={1}
																											data-lang={'pt'}
																											data-type={'doc'}
																											className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																											onChange={onChangeHandlerFilesPDFRMMAprovacao}
																										/>
																									</div>
																								</div>

																								<div className="row">
																									{
																									rmm_el?.file?.aprovacao?.name !== undefined && rmm_el.file.aprovacao.name !== '' ?
																										<SortableTree
																											isVirtualized={false}
																											treeData={[{ id: 1, id_doc: '', title: rmm_el.file.aprovacao.name, link: rmm_el.file.aprovacao.link, visible: true }]}
																											maxDepth={1}
																											canDrag={false}
																											//onChange={() => console.log('onChange')}
																											onChange={() => {}}
																											getNodeKey={({ node }) => node.id}
																											generateNodeProps={extendedNode => ({
																												title: (
																													<>
																														<span>{extendedNode.node.title}</span>
																														<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={rmm_el.id} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf_rmm_aprovacao} />
																													</>
																												),
																												buttons: [
																													<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																													<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																													<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																													<button type="button" onClick={() => remove_element_tree_pdf_rmm_aprovacao(rmm_el.id, 1, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																												],
																											})}
																										/>
																									:
																										null
																									}
																								</div>
																							</div>
																						</div>

																					</div>
																				</div>
																			</div>
																		)
																	})
																:
																	null
																}
															</div>
														</div>
													:
														null
													}

													<div className="row mb-4 d-none">
														<div className="col-12 col-md-4">
															<div className="div-doc">
																<label className="col-form-label fw-bold fs-6">{language[lang].pdf_rmm}</label>

																<div className="dropzone-panel mb-lg-0 mb-2">
																	<div className="div-form-input col-12 custom-file">
																		<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-rmm-" + 0 + '-' + 1}>{language[lang].doc_choose}</label>
																		<input
																			id={"input-files-rmm-" + 0 + '-' + 1}
																			type="file"
																			accept="application/pdf"
																			data-order={0}
																			data-langid={1}
																			data-lang={'pt'}
																			data-type={'doc'}
																			className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																			onChange={onChangeHandlerFilesPDFRMM}
																			multiple
																		/>
																	</div>
																</div>

																<div className="row">
																	{
																		treeDataPDFRMM[0] !== undefined && treeDataPDFRMM[0][1] !== undefined ?
																			<SortableTree
																				isVirtualized={false}
																				treeData={treeDataPDFRMM[0][1]}
																				maxDepth={1}
																				canDrag={false}
																				//onChange={() => console.log('onChange')}
																				onChange={treeDataPDFRMM => handle_change_tree_pdf_fatura(treeDataPDFRMM, 0, 1)}
																				getNodeKey={({ node }) => node.id}
																				generateNodeProps={extendedNode => ({
																					title: (
																						<>
																							<span>{extendedNode.node.title}</span>
																							<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf_rmm} />
																						</>
																					),
																					buttons: [
																						<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																						<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																						<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																						<button type="button" onClick={() => remove_element_tree_pdf_rmm(0, 1, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																					],
																				})}
																			/>
																			:
																			''
																	}
																</div>
															</div>
														</div>
													</div>
												</div>	
											:
												null
											}

											<div className="card-body border-top p-4">
												<div className="row mb-4">
													<div className="col-12 col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].field_edit_responsable}</label>
														<select
															name="edit"
															className="form-select form-control mb-4 mb-lg-0 rounded-0"
															onChange={change_active_responsable}
															value={dados?.current?.info?.responsable?.edit?.id !== undefined && dados?.current?.info?.responsable?.edit?.id !== null ? dados.current.info.responsable.edit?.id : ''}
														>
															<option value="">{language[lang].field_choose_respnsable}</option>
															{
																entities_list.current !== undefined && entities_list.current !== null ?
																	entities_list.current.map((el_el, k_el) => (
																		<option key={k_el} value={el_el.id}>
																			{el_el.label}
																		</option>
																	))
																	:
																	null
															}
														</select>
													</div>
													<div className="col-12 col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].field_aproval_responsable}</label>
														<select
															name="aproval"
															className="form-select form-control mb-4 mb-lg-0 rounded-0"
															onChange={change_active_responsable}
															value={dados?.current?.info?.responsable?.aproval?.id !== undefined && dados?.current?.info?.responsable?.aproval?.id !== null ? dados.current.info.responsable.aproval?.id : ''}
														>
															<option value="">{language[lang].field_choose_respnsable}</option>
															{
																entities_list.current !== undefined && entities_list.current !== null ?
																	entities_list.current.map((el_el, k_el) => (
																		<option key={k_el} value={el_el.id}>
																			{el_el.label}
																		</option>
																	))
																	:
																	null
															}
														</select>
													</div>
													<div className="col-12 col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].field_remove_responsable}</label>
														<select
															name="remove"
															className="form-select form-control mb-4 mb-lg-0 rounded-0"
															onChange={change_active_responsable}
															value={dados?.current?.info?.responsable?.remove?.id !== undefined && dados?.current?.info?.responsable?.remove?.id !== null ? dados.current.info.responsable.remove?.id : ''}
														>
															<option value="">{language[lang].field_choose_respnsable}</option>
															{
																entities_list.current !== undefined && entities_list.current !== null ?
																	entities_list.current.map((el_el, k_el) => (
																		<option key={k_el} value={el_el.id}>
																			{el_el.label}
																		</option>
																	))
																	:
																	null
															}
														</select>
													</div>
												</div>
											</div>										
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
